import React from 'react';
import { FiGitMerge, FiLayers, FiX } from 'react-icons/fi';

const MergeDuplicatesModal = ({ show, onClose, onConfirm }) => {
  const [selectedOption, setSelectedOption] = React.useState('groups');

  const handleConfirm = () => {
    onConfirm(selectedOption);
    onClose();
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        minWidth: '400px',
        maxWidth: '500px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        position: 'relative'
      }}>
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#666',
            padding: '4px',
            borderRadius: '4px'
          }}
          title="Schließen"
        >
          <FiX />
        </button>

        {/* Title */}
        <h3 style={{
          margin: '0 0 20px 0',
          color: '#333',
          fontSize: '20px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FiGitMerge style={{ color: '#ff9800' }} />
          Duplikate zusammenführen
        </h3>

        {/* Description */}
        <p style={{
          marginBottom: '24px',
          color: '#666',
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          Wählen Sie aus, was zusammengeführt werden soll:
        </p>

        {/* Options */}
        <div style={{ marginBottom: '24px' }}>
          {/* Option 1: Nur Panelgruppen */}
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            marginBottom: '16px',
            cursor: 'pointer',
            padding: '12px',
            borderRadius: '6px',
            border: selectedOption === 'groups' ? '2px solid #ff9800' : '2px solid #e0e0e0',
            backgroundColor: selectedOption === 'groups' ? '#fff3e0' : '#f9f9f9'
          }}>
            <input
              type="radio"
              name="mergeOption"
              value="groups"
              checked={selectedOption === 'groups'}
              onChange={(e) => setSelectedOption(e.target.value)}
              style={{ marginTop: '2px' }}
            />
            <div style={{ flex: 1 }}>
              <div style={{
                fontWeight: 'bold',
                marginBottom: '4px',
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <FiLayers size={16} />
                Nur Panelgruppen zusammenführen
              </div>
              <div style={{ fontSize: '13px', color: '#666' }}>
                Führt nur Panelgruppen mit identischen Namen zusammen. 
                Panels innerhalb der Gruppen bleiben unverändert.
              </div>
            </div>
          </label>

          {/* Option 2: Panelgruppen und Panels */}
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            cursor: 'pointer',
            padding: '12px',
            borderRadius: '6px',
            border: selectedOption === 'both' ? '2px solid #ff9800' : '2px solid #e0e0e0',
            backgroundColor: selectedOption === 'both' ? '#fff3e0' : '#f9f9f9'
          }}>
            <input
              type="radio"
              name="mergeOption"
              value="both"
              checked={selectedOption === 'both'}
              onChange={(e) => setSelectedOption(e.target.value)}
              style={{ marginTop: '2px' }}
            />
            <div style={{ flex: 1 }}>
              <div style={{
                fontWeight: 'bold',
                marginBottom: '4px',
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <FiGitMerge size={16} />
                Panelgruppen und Panels zusammenführen
              </div>
              <div style={{ fontSize: '13px', color: '#666' }}>
                Führt sowohl Panelgruppen als auch Panels mit identischen Namen zusammen. 
                Empfohlen für vollständige Bereinigung nach dem Anhängen von Plänen.
              </div>
            </div>
          </label>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#666',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Abbrechen
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#ff9800',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <FiGitMerge size={14} />
            Zusammenführen
          </button>
        </div>
      </div>
    </div>
  );
};

export default MergeDuplicatesModal;